import icon from './potential_reach.png.js';
import template from './graph_widget_view.html';
import templateMaxView from './graph_widget_max.html';
import templateReportView from './graph_widget_report.html';

angular
    .module('MW.InsDashboard.reachWidget',[
        'MW.Dashboard.DashboardWidgetService',
        'MW.Framework.TranslationService',
        'MW.InsDashboard.insightsBackendService',
        'MW.InsDashboard.ChartService',
        'DashboardChartConfigService',
        'MW.InsDashboard.InsWidgetConfigService',
        'MW.Framework.CoreCommon',
        'MW.InsDashboard.InsightsDataMaps',
        'MW.InsDashboard.TransformSov',
        'MW.InsDashboard.ChartDataService',
        'CoreChartObject',
        'MW.InsDashboard.WidgetController',
        'MW.Configuration',
        'MW.Framework.CoreUserService'])
    .directive('reachWidget', ['DashboardWidgetService', 'translationService' , 'insightsBackendService', 'ChartService', '$filter', '$q', 'DashboardChartConfigService', 'InsWidgetConfigService', 'CoreCommon', 'InsightsDataMaps', 'TransformSov', 'ChartDataService','CoreChartObject', '$controller', 'CoreUserService', function(DashboardWidgetService, translationService, insightsBackendService, ChartService, $filter, $q, DashboardChartConfigService, InsWidgetConfigService, CoreCommon, InsightsDataMaps, TransformSov,ChartDataService, CoreChartObject, $controller, CoreUserService){

    var reachWidget = DashboardWidgetService.getWidget('reach-widget');

    var reachWidgetController = function($scope){
        $controller('WidgetController', {$scope: $scope});//inject the scope and use the basic widget controller
    }

    var reachWidgetLink = function(scope, element) {

        var customData = {
            tooltip: {
                formatter: function(event) {
                    var output = '';
                        output += '<b>' + this.point.name + '</b><br>';
                        output += translationService.getLocalizedString('Reach') + ' (#): ' + Highcharts.numberFormat(Math.abs(this.point.count), 0) + ' / ' + this.point.percent+ '%';
                    return output;
                }
            }
        };
        var chartOverrides = {
            max:customData
        };

        var settingsOverides = {
            yAxisTitle: 'Reach', //used to make the values absolute
            fetchDataForPreviousRange: scope.widget.settings.dateComparison,
        };

        var chartConfiguration = {
            insightsService: 'statisticServiceDateReachHistogram',
            insightsObject : 'dateReachHistograms',
            charts:{
                areaspline:{ chart:ChartService.area,transform:TransformSov.areaspline, dataMap:InsightsDataMaps.datamapDateVolume, customSettings: settingsOverides},
                spline:{ chart:ChartService.line,transform:TransformSov.spline, dataMap:InsightsDataMaps.datamapDateVolume, customSettings: settingsOverides},
                donut:{ chart:ChartService.donut,transform:TransformSov.donut, dataMap:InsightsDataMaps.datamapDateVolume},
                column:{ chart:ChartService.column,transform:TransformSov.column, dataMap:InsightsDataMaps.datamapDateVolume,customSettings: settingsOverides, custom: chartOverrides},
                table: {chart:{},transform:TransformSov.table,dataMap:InsightsDataMaps.datamapDateVolume}
            },
            table: {
                enabled: true,
                rowTitle: translationService.getLocalizedString('Date'),
                summaryTitle: translationService.getLocalizedString('Total'),
                titleField: 'name',
                countField: 'volume',
                percentField: 'sov',
                drilldown: function reachTableDrilldown(datapoint){
                    scope.internalDrillDown(datapoint.id,datapoint.date);
                },
                tooltip: function reachTableTooltip(datapoint){
                    return translationService.getLocalizedString('Reach') + ': ' + datapoint.volume;
                },
                customRowTitleSort: true
            }

        };

        if (scope.widget.settings && scope.widget.settings.previousDateRange && scope.widget.settings.dateComparison) {
            chartConfiguration['previousDateStart'] = moment(scope.widget.settings.previousDateRange.startDate).tz(CoreUserService.getTimezone()).format();
            chartConfiguration['previousDateEnd'] = moment(scope.widget.settings.previousDateRange.endDate).tz(CoreUserService.getTimezone()).format();
        }

        scope.initWidget(chartConfiguration);
    };

    return new WidgetDirective(reachWidget, reachWidgetLink, reachWidgetController);
}])
.run(['DashboardWidgetService', 'translationService', 'CoreCommon','InsWidgetConfigService', 'DASHBOARD_LEGACY_URL', function(DashboardWidgetService, translationService, CoreCommon, InsWidgetConfigService, DASHBOARD_LEGACY_URL) {
    DashboardWidgetService.register({
        name: translationService.getLocalizedString('Potential Reach'),
        app: 'ins_dashboard',
        description: translationService.getLocalizedString('The Potential Reach widget gives insight into the number of ' +
                                                           'potential viewers that have been exposed to a brand, product, ' +
                                                           'event or topic over a specified date range. It is useful to ' +
                                                           'understand reach because it helps you identify the size of the ' +
                                                           'potential audience, as opposed to limiting the analysis to the ' +
                                                           'number of articles a brand has been mentioned in. The Potential ' +
                                                           'Reach widget can display up to five separate inputs.'),
        directive: 'reach-widget',
        icon,
        defaultSettings: {
            'width': 'third',
            'title': 'Title',
            'description': '',
            'maxAgents': 5
        },
        displayOrder: 2,
        allowExport: true,
        requiredSettings: ['dateRange'],
        availableSettings: ['dateRange','title','chartType','positioningData','labelFormat', 'news','broadcast','rss','tags','dateBreakouts', 'labelVisibility', 'dateComparison'],
        availableChartTypes:[{name:'Line',id:'spline'}, {name:'Bar',id:'column'},{name:'Area',id:'areaspline'}, {name:'Donut', id:'donut'}],
        getDefaultChartType: function() {
            if (CoreCommon.isUsable(this.settings.inputs) && this.settings.inputs.length > 1)
                return this.availableChartTypes[1];
            else
                return this.availableChartTypes[0];
        },
        hasRequiredSettings: function(){
            var _widget = this;
            return InsWidgetConfigService.hasSelectedAnInput(_widget);
        },
        template,
        templateMaxView,
        templateReportView
    });
}]);

